import React, { Component } from 'react';
import { LoadingIndicator, ProgressBar, Button } from '../../components';
import LearningContent from './learning-content';
import PropTypes from 'prop-types';
import ReactCSSTransitionReplace from 'react-css-transition-replace';
import queryString from 'query-string';
import BulletinIcon from '@material-ui/icons/TurnedIn';
import { ThemeColors } from '../../theme';
import courses from '../../../images/courses@2x.png';
import tests from '../../../images/tests@2x.png';
import restart from '../../../images/restart.png';
import pdf from '../../../images/pdf.png';
import Group from '../courses/group';
import ENV from '../../../run-config';
import { findItem } from '../../util/groupStructureHelpers';
import { withStyles } from '@material-ui/core';

const INITIAL_STATE = {
  cardIndex: 0,
  progress: 0,
};

const styles = {
  buttonStyle: {
    fontSize: '14px',
    height: 60,
  },
  sideButtonStyle: {
    textAlign: 'left',
    display: 'block',
    minWidth: 200,
    marginBottom: 5,
    height: 50,
  },
  iconStyle: {
    width: 45,
    height: 45,
  },
};

class Course extends Component {
  constructor(props) {
    super(props);

    this.state = INITIAL_STATE;
    this.exportView = queryString.parse(this.props.location.search).exportView;
    this.hideCourseEnd = queryString.parse(this.props.location.search).hideCourseEnd;
  }

  componentDidMount() {
    if (!this.props.course) {
      this.props.loadCourse({ id: this.props.match.params.courseId });
    }

    const cardId = queryString.parse(this.props.location.search).cardId;
    if (cardId) {
      this.props.loadCard({ cardId });
    }
    window.scrollTo(0, 0);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.courseRunStartedAt &&
      nextProps.courseRunStartedAt !== this.props.courseRunStartedAt) {
      this.setState({
        ...INITIAL_STATE,
        progress: 1 / nextProps.cards.length,
      });
    }

    if (nextProps.cards && (!this.state.progress || this.state.progress >= 1)) {
      this.setState({
        progress: 1 / nextProps.cards.length,
      });
    }
  }

  onClickShare() {
    const currentCard = this.getCurrentCard();
    const url = `${ENV.apiHost}/courses/${this.props.course.id}?cardId=${currentCard.id}&exportView=true`;
    this.props.onExportContent(url);
  }

  onCardSwiped = (actionType, card) => {
    if (actionType === 0 || this.props.course.courseType === 0) {
      this.props.onCardSwiped(actionType, card);
    }

    if (card.id === this.props.cards[this.props.cards.length - 1].id) {
      this.props.onFinishRun();
      this.setState({
        progress: 1 / this.props.cards.length,
        cardIndex: 0,
      });
      return;
    }

    let increment = 1;

    if (this.props.course.courseType === 1 && actionType === 1) {
      increment = -1;
    }

    const cardIndex = this.state.cardIndex + increment;
    const progress = (cardIndex + 1) / this.props.cards.length;
    this.setState({
      progress,
      cardIndex,
    });
  }

  getCurrentCard() {
    return this.props.cards[this.state.cardIndex] ?
    this.props.cards[this.state.cardIndex] :
    this.props.currentCard;
  }

  getCardByIndexOrId() {
    let card = this.props.cards[this.state.cardIndex];
    const cardId = queryString.parse(this.props.location.search).cardId;
    if (cardId) {
      card = this.props.cards.find(c => c.id === cardId);
    }
    return card;
  }

  loadCourse = (course) => {
    this.props.loadCourse(course);
    this.props.history.push(`/courses/${course.id}`);
  }

  handlePinContent = (event, id) => {
    event.preventDefault();
    event.stopPropagation();

    const pinContentDto = {
      contentType: 'card',
      contentId: id,
    };

    this.props.pinOrUnpinContent(this.props.bulletinBoard.id, pinContentDto);
  }

  handleGoToTest = (testId) => {
    const testRuns = this.props.testRuns;
    const openRunForTest = testRuns.find(t => t.testId === testId);
    if (openRunForTest) {
      this.props.loadTest({ id: testId });
      this.props.setTestRun(openRunForTest);
    } else {
      this.props.startNewTestRun({ id: testId });
    }

    this.props.history.push(`/tests/${this.props.course.testId}`);
  }

  renderGoToTestButton() {
    if (!this.props.course.testId) {
      return null;
    }

    const test = findItem(this.props.tests, this.props.course.testId, 'test');

    if (!test) return null;


    return (
      <Button
        onClick={() => {
          this.handleGoToTest(this.props.course.testId);
        }}
        label="Zum Test"
        icon={<img src={tests} style={{ width: 45, height: 45 }} alt="Tests" />}
        style={styles.sideButtonStyle}
        secondary
        labelStyle={{ color: '#222', textAlign: 'left', marginTop: 10 }}
      />
    );
  }


  renderExportButton() {
    if (!ENV.exportFeature || (
      this.props.config.sharingEnabled && this.props.config.sharingEnabled === 'false')) {
      return null;
    }

    return (
      <Button
        onClick={() => this.onClickShare()}
        label="Kärtchen jetzt downloaden"
        style={styles.sideButtonStyle}
        icon={<img src={pdf} alt="pdf" style={styles.iconStyle} />}
      />
    );
  }

  renderBulletinButton() {
    if (!this.props.config || this.props.config.bulletinBoardActive != 'true') return null;
    const currentCard = this.getCurrentCard();

    const title = currentCard.isPinned
    ? 'Von meinen Inhalten entfernen'
    : 'Zu meinen Inhalten hinzufügen';

    const buttonStyle = {
      textAlign: 'left',
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      minWidth: 200,
      marginBottom: 5,
      height: 50,
    };

    return (
      <Button
        onClick={e => this.handlePinContent(e, currentCard.id)}
        label={title}
        style={buttonStyle}
        icon={<BulletinIcon style={{ height: 25, width: 25, marginRight: 10, marginLeft: 10 }} />}
      />
    );
  }

  renderButtons() {
    const retryOpenCards = this.props.unknownCardsAvailable ?
      (<Button
        onClick={this.props.onRetry}
        label="Offene Kärtchen wiederholen"
        style={styles.sideButtonStyle}
        icon={<img src={restart} style={styles.iconStyle} alt="Kärtchen wiederholen" />}
        secondary
        labelStyle={{ textAlign: 'left', color: '#222' }}
      />) :
    null;

    return (
      <div style={{ marginTop: 20 }}>
        {retryOpenCards}
        <Button
          onClick={this.props.onRestart}
          label="Kurs neu starten"
          style={styles.sideButtonStyle}
          icon={<img src={restart} style={styles.iconStyle} alt="start course" />}
          secondary
          labelStyle={{ textAlign: 'left', color: '#222' }}
        />
        <Button
          onClick={() => {
            this.props.history.push('/courses');
            this.props.onLoadCourses();
          }}
          label="Zu den Kursen"
          style={styles.sideButtonStyle}
          secondary
          icon={<img src={courses} style={{ width: 45, height: 45 }} alt="Zu den Kursen" />}
          labelStyle={{ color: '#222', textAlign: 'left' }}
        />
        {this.renderExportButton()}
        {this.renderGoToTestButton()}
        {this.renderBulletinButton()}
      </div>
    );
  }

  renderYupButton(card) {
    return (
      <Button
        label={this.props.course.courseType === 0 ? ENV.positiveCardCTA : 'Weiter'}
        onClick={() => this.onCardSwiped(0, card)}
        className={'pm-course-button'}
        style={{
          ...styles.buttonStyle,
          ...{ background: ThemeColors.positiveColor, marginLeft: 5 },
          marginLeft: (this.props.course.courseType === 1 && this.state.cardIndex == 0) ? '50%' : 5,
        }}
        labelStyle={{ color: ThemeColors.positiveColorTextColor, fontSize: 12 }}
        variant="contained"
      />
    );
  }

  renderNopeButton(card) {
    if (this.props.course.courseType === 1 && this.state.cardIndex == 0) return null;
    return (
      <Button
        label={this.props.course.courseType === 0 ? ENV.negativeCardCTA : 'Zurück'}
        onClick={() => this.onCardSwiped(1, card)}
        className={'pm-course-button pm-course-button-first'}
        style={{ ...styles.buttonStyle, ...{ background: ThemeColors.negativeColor } }}
        variant="contained"
        labelStyle={{ color: '#fff', fontSize: 12 }}
      />
    );
  }

  renderLearningContent(card) {
    const { classes } = this.props;
    return (
      <ReactCSSTransitionReplace
        transitionName="carousel-swap"
        style={{ maxHeight: '100%'}}
      >
        <LearningContent
          content={card}
          key={card && card.id}
          showAll={this.exportView}
          hideCourseEnd={this.hideCourseEnd}
        />
      </ReactCSSTransitionReplace>
    );
  }


  renderContent() {
    if (!this.props.completedDialogOpen &&
      (!this.props.cards || !this.props.cards.length) &&
      !this.props.currentCard) {
      return (
        <div className="col-lg-10 text-center">
          <h3 className="text-center">Keine Kärtchen verfügbar.</h3>
        </div>
      );
    }

    let card = this.getCardByIndexOrId();

    if (!card) card = this.props.currentCard;

    if (!card) {
      return null;
    }

    return (
      <div style={{ marginBottom: '40px', overflow: 'hidden' }}>
        <div className="col-sm-12 col-md-8 col-lg-8" style={{ marginBottom: '40px', overflow: 'hidden' }}>
          {this.renderLearningContent(card)}
          <div style={{ marginTop: '20px', marginLeft: 10, textAlign: 'right', display: 'flex' }} className="doNotPrint">
            {this.renderNopeButton(card)}
            {this.renderYupButton(card)}
          </div>
        </div>

        <div className="col-sm-12 col-md-4 col-lg-4 doNotPrint">
          {this.renderButtons()}
        </div>
      </div>
    );
  }

  render() {
    if (this.props.isLoading) {
      return <LoadingIndicator show centered />;
    }

    if (!this.props.course) {
      return null;
    }

    return (
      <div>
        <div>
          <div style={{ backgroundColor: '#f8f8f8', overflow: 'hidden' }}>
            <div className="col-md-12 col-lg-12" id="headlineDiv">
              <div>
                <h1 style={{ color: ThemeColors.accent2Color }}>{this.props.course.name}</h1>
                <p style={{ color: ThemeColors.accent2Color }}>{this.props.course.description}</p>
                <span style={{ right: 10, position: 'absolute', top: 30 }}>{this.state.cardIndex + 1}/{this.props.cards.length}</span>
              </div>
              <div>
                <ProgressBar progress={this.state.progress} />
              </div>
            </div>
          </div>
          {this.renderContent()}
        </div>
        <div style={{ backgroundColor: '#f8f8f8', height: 30 }} />
        {/* <div> */}
        <div className="doNotPrint col-md-12 col-lg-10" style={{ marginBottom: 50, marginTop: 10 }}>
          <Group
            group={{ name: 'Weitere Inhalte', children: this.props.courses }}
            onClick={this.loadCourse}
          />
        </div>
      </div>
    );
  }
}


const classStyles = theme => ({
  learningContent: {
    // [theme.breakpoints.down('sm')]: {
    //   minHeight: 600,
    // },
    // [theme.breakpoints.down('xs')]: {
    //   minHeight: 600,
    // },
  },
});

Course.propTypes = {
  config: PropTypes.object,
  location: PropTypes.object,
  course: PropTypes.object,
  match: PropTypes.object,
  currentCard: PropTypes.object,
  history: PropTypes.object,
  bulletinBoard: PropTypes.object,
  loadCourse: PropTypes.func,
  onExportContent: PropTypes.func,
  onCardSwiped: PropTypes.func,
  onFinishRun: PropTypes.func,
  pinOrUnpinContent: PropTypes.func,
  loadTest: PropTypes.func,
  setTestRun: PropTypes.func,
  startNewTestRun: PropTypes.func,
  onRestart: PropTypes.func,
  onLoadCourses: PropTypes.func,
  loadCard: PropTypes.func,
  onRetry: PropTypes.func,
  cards: PropTypes.array,
  testRuns: PropTypes.array,
  courses: PropTypes.array,
  unknownCardsAvailable: PropTypes.bool,
  completedDialogOpen: PropTypes.bool,
  isLoading: PropTypes.bool,
  courseRunStartedAt: PropTypes.any,

};

Course.defaultProps = {
  config: {},
  location: null,
  course: null,
  match: null,
  currentCard: null,
  history: null,
  bulletinBoard: null,
  loadCourse: () => {},
  onExportContent: () => {},
  onCardSwiped: () => {},
  onFinishRun: () => {},
  pinOrUnpinContent: () => {},
  loadTest: () => {},
  setTestRun: () => {},
  startNewTestRun: () => {},
  onRestart: () => {},
  onLoadCourses: () => {},
  loadCard: () => {},
  onRetry: () => {},
  cards: [],
  testRuns: [],
  courses: [],
  unknownCardsAvailable: false,
  completedDialogOpen: false,
  isLoading: false,
  courseRunStartedAt: null,
};

export default withStyles(classStyles)(Course);



// WEBPACK FOOTER //
// ./src/app/main/course/course.js